import { Skeleton } from '@/components/ui/skeleton';

export function DashboardSkeleton() {
  return (
    <div className="space-y-8">
      {/* Header skeleton */}
      <div className="space-y-3">
        <Skeleton className="h-10 w-64" />
        <Skeleton className="h-5 w-48" />
        <Skeleton className="h-12 w-full rounded-[4px]" />
        <Skeleton className="h-5 w-80" />
      </div>

      {/* Section A skeleton */}
      <div className="space-y-3">
        <Skeleton className="h-8 w-40" />
        {[1, 2, 3].map((i) => (
          <div key={i} className="flex items-center gap-3 py-4 border-b border-[var(--muted)]">
            <Skeleton className="h-5 w-5 rounded-[4px] shrink-0" />
            <div className="flex-1 space-y-1">
              <Skeleton className="h-4 w-3/4" />
              <Skeleton className="h-3 w-1/2" />
            </div>
          </div>
        ))}
      </div>

      {/* Section B skeleton */}
      <div className="space-y-3">
        <Skeleton className="h-8 w-32" />
        {[1, 2].map((i) => (
          <div key={i} className="rounded-[4px] border p-5 space-y-2">
            <Skeleton className="h-5 w-3/4" />
            <Skeleton className="h-4 w-full" />
            <div className="flex gap-4 pt-2">
              <Skeleton className="h-6 w-24" />
              <Skeleton className="h-6 w-24" />
            </div>
          </div>
        ))}
      </div>

      {/* Section C skeleton */}
      <div className="space-y-3">
        <Skeleton className="h-8 w-40" />
        {[1, 2].map((i) => (
          <div key={i} className="rounded-[4px] border p-5 space-y-2">
            <Skeleton className="h-5 w-2/3" />
            <Skeleton className="h-4 w-full" />
          </div>
        ))}
      </div>
    </div>
  );
}

export function DetailSkeleton() {
  return (
    <div className="space-y-6">
      <Skeleton className="h-8 w-3/4" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-5/6" />
      <div className="flex gap-4">
        <Skeleton className="h-6 w-28" />
        <Skeleton className="h-6 w-28" />
      </div>
    </div>
  );
}
